import { __ } from "../../utilities";
import { connect } from "react-redux";
import { useAuth } from "@sportnet/auth-react";
import AppContext from "@sportnet/ui/TheLayout/AppContext";
import Button from "@sportnet/ui/Button";
import HeaderBar from "@sportnet/ui/HeaderBar";
import Layout from "../../components/Layout";
import React from "react";
import Segment from "@sportnet/ui/Segment";
import apiEshop from "../../service/apiEshop";
import styled from "styled-components";

const CenterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
`;

const ProgressCircle = ({ progress }) => {
  const size = 120;
  const strokeWidth = 8;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (progress / 100) * circumference;

  return (
    <svg width={size} height={size} style={{ marginBottom: 24 }}>
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke="#e6e6e6"
        strokeWidth={strokeWidth}
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke="#1890ff"
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
        style={{ transition: "stroke-dashoffset 0.4s ease" }}
      />
      <text
        x="50%"
        y="50%"
        dominantBaseline="central"
        textAnchor="middle"
        fontSize="20"
        fill="#333"
      >
        {Math.round(progress)}%
      </text>
    </svg>
  );
};

const ExportProducts = () => {
  const [isFetching, setIsFetching] = React.useState(false);
  const [progress, setProgress] = React.useState(0);
  const intervalRef = React.useRef(null);
  const { ppo } = useAuth();

  const stopProgress = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const handleClickExport = async () => {
    setIsFetching(true);
    setProgress(0);

    const startTime = Date.now();
    const expectedDuration = 5000;

    intervalRef.current = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const linear = Math.min(elapsed / expectedDuration, 1);
      // ease-out: rychly zaciatok, spomaluje sa ku koncu, max 95%
      const eased = 1 - Math.pow(1 - linear, 3);
      setProgress(eased * 95);
    }, 100);

    try {
      const response = await apiEshop.adminExportProductsCsv(ppo);
      const contentLength = response.headers.get("Content-Length");
      const totalBytes = contentLength ? parseInt(contentLength, 10) : 0;

      if (totalBytes && response.body) {
        stopProgress();
        const reader = response.body.getReader();
        const chunks = [];
        let receivedBytes = 0;

        let done = false;
        while (!done) {
          const result = await reader.read();
          done = result.done;
          if (done) break;
          const value = result.value;
          chunks.push(value);
          receivedBytes += value.length;
          setProgress((receivedBytes / totalBytes) * 100);
        }

        const blob = new Blob(chunks);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "products.csv";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } else {
        // fallback: nemame Content-Length, nechame simulovany progress bezat
        const blob = await response.blob();
        stopProgress();
        setProgress(100);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "products.csv";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (e) {
      console.error(e);
      stopProgress();
    } finally {
      setTimeout(() => {
        setIsFetching(false);
        setProgress(0);
      }, 1000);
    }
  };

  React.useEffect(() => {
    return () => stopProgress();
  }, []);

  return (
    <Layout
      topFixed={
        <HeaderBar>
          <HeaderBar.Header>{__("Export produktov")}</HeaderBar.Header>
        </HeaderBar>
      }
    >
      <AppContext title={__("Export produktov")} />
      <Segment>
        <Segment raised noBottomGutter>
          <CenterWrapper>
            {isFetching ? (
              <ProgressCircle progress={progress} />
            ) : (
              <Button primary onClick={handleClickExport} size="large">
                {__("Exportovať produkty do CSV")}
              </Button>
            )}
          </CenterWrapper>
        </Segment>
      </Segment>
    </Layout>
  );
};

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps)(ExportProducts);
